/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { constants, ARABIC_PERIODS, UNSUCCESSFULSELL, DEFAULT_CURRENCY } from '../../constants';
import { inspect } from 'util';
import { logger } from './logger';
import moment, { Moment } from 'moment';
import { addSubDirectoryPrefix, getLanguage } from './subDirectoryFunctions';
import { LOCALE_ZH_CN } from '@marriott/mi-ui-library';
import { getDeployedEnvType } from '@marriott/mi-apollo-client-utils';
import { JP_LOCALE, KR_LOCALE, AR_LOCALE, HI_LOCALE } from '../../modules/constants';
import { baseVariables } from '@marriott/mi-ui-library';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
declare global {
  // eslint-disable-next-line no-var
  var loggerInstance: CallableFunction;
}

const { NEXT_PUBLIC_DYNAMIC_ROUTING_URL } = process.env;

const { ROUTING_CONFIG, APPLICATION_NAME, EXPERIENCE_SEGMENT, SESSION_SEARCH_KEYS } = constants;
const { NEXT_PUBLIC_DEFAULT_LANG } = process.env;
export const canUseDOM = !!(typeof window !== 'undefined' && window.document);

export function getItemFromPageModel(pageModel: any, itemPath: string) {
  const parts = itemPath.split('/');
  let obj = pageModel;

  for (let i = 0; i < parts.length && obj; i++) {
    obj = (obj[':items'] || {})[parts[i]];
  }

  return obj || {};
}

export const getProcessEnvs = () => {
  if (canUseDOM) {
    const envTag = document.getElementById('__SERVERENV__');
    if (envTag && envTag.innerHTML) {
      const envObject = JSON.parse(envTag.innerHTML);
      return envObject;
    }
    return process.env;
  }
  return process.env;
};

const { SESSION_GET_CALL_URL_CLIENT } = process.env;

export async function getPageModel(path: string, locale: string, sessionID: string, requestId: string) {
  const { log } = global.loggerInstance('ModelCall');
  // const locale = preData?.contexts?.global?.localeKey?.toLowerCase()?.replace('_', '-');
  locale = locale?.replace('_', '-');
  const pagePath = path.split('?')[0];

  const getCMSTemplateReqBody = {
    requestType: ROUTING_CONFIG,
    seoUrl: pagePath,
    localeKey: locale,
    experienceSegment: EXPERIENCE_SEGMENT,
    applicationName: APPLICATION_NAME,
    sessionToken: sessionID,
  };

  let pageModel: any = {};
  try {
    log.debug(`[STEP 5] NEXT_PUBLIC_DYNAMIC_ROUTING_URL: ${NEXT_PUBLIC_DYNAMIC_ROUTING_URL}`);
    log.debug(`[STEP 5] getCMSTemplateReqBody: ${JSON.stringify(getCMSTemplateReqBody)}`);
    const response = await axios.post(`${NEXT_PUBLIC_DYNAMIC_ROUTING_URL}`, getCMSTemplateReqBody, {
      headers: {
        'x-request-id': requestId,
      },
    });
    if (response) {
      log.debug(`[STEP 5] AEM model API call success with data: ${inspect(response?.data?.data)}`);
      pageModel = response?.data?.data;
    }
  } catch (err) {
    log.error(`[STEP 5] AEM Model API call failed: ${err}`);
    //returing page model and logging error
    return pageModel;
  }
  return pageModel;
}

export async function getSessionData(sessionIDVal: string, requestId: string) {
  let sessionData;
  let sessionHeader: any = {};
  const { log } = global.loggerInstance('SessionCall');
  const apiStartTime = new Date().getTime();
  try {
    log.debug(`[Session Data] This is the MI_SESSION_APP_URL that we are using: ${SESSION_GET_CALL_URL_CLIENT}`);
    log.debug(`[Session Data] This is the session token that we are using: ${sessionIDVal}`);
    const response = await axios.get(`${SESSION_GET_CALL_URL_CLIENT}`, {
      headers: {
        Cookie: `sessionID=${sessionIDVal}`,
        'x-request-id': requestId,
      },
    });
    sessionHeader = response?.headers;
    sessionData = response?.data;
    log.debug(`[Session Data] Session Data Loaded, ${sessionData}`);
  } catch (e) {
    log.debug('[Session Data] Error with session route!', e);
  }
  log.debug('API call performance timing', apiStartTime, new Date().getTime());
  return { sessionData, sessionHeader };
}

export function getDataLayerScript(dataLayer: { data: any; mvpOffersData: string }) {
  return `var dataLayer = ${dataLayer?.data ? JSON.stringify(dataLayer?.data[0]) : '{}'}; var mvpOffers = ${
    dataLayer?.mvpOffersData && dataLayer?.mvpOffersData !== 'null' ? dataLayer?.mvpOffersData : '{}'
  };`;
}

/**
 * method to handle redirects for configured error pages.
 * Keeping it centralized in case approach needs to change or if we
 * add additional error pages.
 * @returns {string} redirectUrl
 */
export const handleErrorPageRedirects = function () {
  const { log } = logger({})('HandleErrorPageRedirects');
  if (process.env['REDIRECT_URL']) {
    return addSubDirectoryPrefix(process.env['REDIRECT_URL']);
  } else {
    log.debug("process.env['REDIRECT_URL'] not available");
    return '/';
  }
};

/**
 * Method to update error message in session document. This method should be
 * used when we need to add a new error message in session document, which can
 * then be read to show the message in Aries Advanced Search Page.
 * @returns {object} sessionDoc
 */
export const updateSessionDocErrorMessages = async (
  sessionID: string,
  SESSION_APP_GET_CALL_URL: string,
  sessionUpdateURL: string,
  errorMessageKeys: string[]
) => {
  // TODO - build an endpoint generator and replace this URL with method call.
  const sessionUrl: string = SESSION_APP_GET_CALL_URL;
  const requestId = useClientEnvVarsStore.getState().envVarsObject['REQUEST_ID'];
  const removeBlock: any = [];

  try {
    const response = await axios.post(
      sessionUrl,
      {
        keys: SESSION_SEARCH_KEYS,
      },
      {
        headers: {
          Cookie: `sessionID=${sessionID}`,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'x-request-id': requestId,
        },
      }
    );
    const sessionDoc = response.data;
    const sessionDocCopy = JSON.parse(JSON.stringify(sessionDoc));

    const AriesSearchPayloadObject: any = {};

    if (sessionDoc?.cacheDatadata?.data?.AriesSearch) {
      // remove the searchCriteria, if searchCriteria is therethe searchform won't load on advance search page
      removeBlock?.push('AriesSearch.searchCriteria');
      AriesSearchPayloadObject['AriesSearch.errorMessages.submitSearchFormErrorMessages'] = { errorMessageKeys };
    }
    await axios.patch(
      sessionUpdateURL,
      {
        createOrUpdate: {
          AriesSearch: AriesSearchPayloadObject,
        },
        remove: removeBlock,
        sessionToken: sessionID,
      },
      {
        headers: {
          Cookie: `sessionID=${sessionID}`,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Accept-Language': getLanguage() || NEXT_PUBLIC_DEFAULT_LANG || '',
          'x-request-id': requestId,
        },
      }
    );
    // returning old copy of session data, which can be used to construce params
    // for redirection URL
    return sessionDocCopy.data;
  } catch (error) {
    return error;
  }
};

/**
 * Method to form and return search page query URL
 * @param sessionData {object}
 * @param errorCode {string}
 * @returns {string} searchPageQueryParams
 */
export function formAdvanceSearchPageQuery({
  sessionData,
  errorCode = '',
  addErrorParams = false,
}: {
  sessionData: any;
  errorCode?: string;
  addErrorParams?: boolean;
}): string {
  return `roomTypeCode=&recordsPerPage=40&autoSuggestItemType=&destinationAddress.types=&destinationAddress.latitude=${
    sessionData?.AriesSearch?.searchCriteria?.address?.latitude
  }&propertyCode=&destinationAddress.stateProvinceShort=&isInternalSearch=true&destinationAddress.cityPopulation=&vsInitialRequest=false&searchType=${
    sessionData?.AriesSearch?.searchCriteria?.searchType
  }&destinationAddress.locality=&showAddressPin=&destinationAddress.stateProvinceDisplayName=&destinationAddress.destinationPageDestinationAddress=&countryName=&destinationAddress.stateProvince=${
    sessionData?.AriesSearch?.searchCriteria?.address?.stateProvince
  }&searchRadius=${sessionData?.AriesSearch?.searchCriteria?.searchRadius}&singleSearchAutoSuggest=${
    sessionData?.AriesSearch?.searchCriteria?.singleSearchAutoSuggest
  }&destinationAddress.placeId=${
    sessionData?.AriesSearch?.searchCriteria?.destinationAddressPlaceId
  }&airportName=&for-hotels-nearme=Near&suggestionsPropertyCode=&destinationAddress.country=${
    sessionData?.AriesSearch?.searchCriteria?.address?.country
  }&destinationAddress.name=&poiCity=&destinationAddress.countryShort=&poiName=&destinationAddress.address=${
    sessionData?.AriesSearch?.searchCriteria?.address?.destination
  }&search-countryRegion=&collapseAccordian=is-hidden&singleSearch=true&destinationAddress.cityPopulationDensity=&destinationAddress.secondaryText=${
    sessionData?.AriesSearch?.searchCriteria?.destinationAddressSecondaryText
  }&destinationAddress.postalCode=&destinationAddress.city=${
    sessionData?.AriesSearch?.searchCriteria?.address?.city
  }&destinationAddress.mainText=${
    sessionData?.AriesSearch?.searchCriteria?.destinationAddressMainText
  }&airportCode=&isTransient=true&destinationAddress.longitude=${
    sessionData?.AriesSearch?.searchCriteria?.address?.longitude
  }&initialRequest=false&destinationAddress.website=&search-locality=&roomTypeCode=&propertyCode=&flexibleDateSearchRateDisplay=false&propertyName=&isSearch=true&marriottRewardsNumber=&isRateCalendar=false&incentiveType_Number=&incentiveType=&flexibleDateLowestRateMonth=&flexibleDateLowestRateDate=&isMultiRateSearch=&multiRateMaxCount=&multiRateCorpCodes=&useMultiRateRewardsPoints=&multiRateClusterCodes=&multiRateCorpCodesEntered=&lowestRegularRate=&js-location-nearme-values=&destinationAddress.destination=${
    sessionData?.AriesSearch?.searchCriteria?.address?.destination
  }&fromToDate=&fromToDate_submit=${moment(
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkOutDate
  )?.format('MM/DD/YYYY')}&fromDate=${moment(
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate
  )?.format('MM/DD/YYYY')}&toDate=${moment(
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkOutDate
  )?.format('MM/DD/YYYY')}&toDateDefaultFormat=${moment(
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkOutDate
  )?.format('MM/DD/YYYY')}&fromDateDefaultFormat=${moment(
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate
  )?.format('MM/DD/YYYY')}&flexibleDateSearch=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate
  }&isHideFlexibleDateCalendar=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.hideFlexibleDateCalendar
  }&t-start=${moment(sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate)?.format(
    'YYYY-MM-DD'
  )}&t-end=${moment(sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkOutDate)?.format(
    'YYYY-MM-DD'
  )}&lengthOfStay=${sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.lengthOfStay}&roomCountBox=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.numRooms
  } Room&roomCount=${sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.numRooms}&guestCountBox=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.numAdultsPerRoom
  } Adult Per Room&numAdultsPerRoom=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.numAdultsPerRoom
  }&childrenCountBox=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.numChildrenPerRoom
  } Children Per Room&childrenCount=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.numChildrenPerRoom
  }&childrenAges=${sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.childrenAges?.join(
    ','
  )}&clusterCode=${sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode}&corporateCode=${
    sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode
  }&useRewardsPoints=${sessionData?.AriesSearch?.searchCriteria?.availabilityRequestVO?.rewardsRedemption}${
    addErrorParams
      ? `&useRequestCriteria=true&showErrors=true${errorCode ? '&availabilityErrorCode=' + errorCode : ''}`
      : ''
  }`;
}
export const changeCountryCodeForChina = (countryCode: string) => {
  if (countryCode === 'HK' || countryCode === 'MO' || countryCode === 'TW') {
    return 'CN';
  } else {
    return countryCode;
  }
};
/**
 * This function will fetch mock modal from Local for find hotel page in local development mode.
 * @returns {object} mockmodal
 */
export const getMockPageModel = async (page: string) => {
  const { log } = global.loggerInstance('MockModelCall');
  try {
    const response =
      page === 'HQV'
        ? await import('./_localDevMocks/hqvMockModel').then(data => {
            return data?.HQVModel;
          })
        : await import('./_localDevMocks/findHotelMock').then(data => {
            return data?.FindHotelModel;
          });
    return response;
  } catch (err) {
    log.error(`Mock model loading failed: ${err}`);
    return null;
  }
};

// /**
//  * This function will fetch mock modal from AEM for find hotel page in local development mode.
//  * @returns {object} mockmodal
//  */
// export const getMockPageModel = async () => {
//   const { log } = global.loggerInstance('MockModelCall');
//   try {
//     const response = await axios.get('https://marriott-sites-dev.adobecqms.net/etc.clientlibs/mi-aem-shop/clientlibs/clientlib-mock-model.min.js');
//     return response?.data;
//   } catch (err) {
//     log.error(`Mock model loading failed: ${err}`);
//   }
// };

/**
 * This function will fetch mock session data from local in local development mode.
 * @returns {object} sessionmock
 */
export const getMockSessionData = async () => {
  const { log } = global.loggerInstance('MockSessionDataCall');
  try {
    const response = await import('./_localDevMocks/sessionData').then(data => {
      return data?.mockSessionData;
    });
    return response;
  } catch (err) {
    log.error(`Mock sessionData loading failed: ${err}`);
    return null;
  }
};

//TODO: replace URL once AEM team team share it.
// /**
//  * This function will fetch mock session data from AEM in local development mode.
//  * @returns {object} sessionmock
//  */
// export const getMockSessionData = async () => {
//   const { log } = global.loggerInstance('MockSessionDataCall');
//   try {
//     const response = await axios.get('https://marriott-sites-dev.adobecqms.net/etc.clientlibs/mi-aem-shop/clientlibs/clientlib-mock-model.min.js');
//     return response?.data;
//   } catch (err) {
//     log.error(`Mock sessionData loading failed: ${err}`);
//   }
// };

/**
 * This function will fetch mock search result data from local for search results in local development mode.
 * @returns {object} mockmodal
 */
export const getMockSearchResultData = async () => {
  const { log } = global.loggerInstance('MockSearchResultDataCall');
  try {
    const response = await import('./_localDevMocks/mockSearchResultData').then(data => {
      return data?.SearchResultMockData;
    });
    return response;
  } catch (err) {
    log.error(err);
    return null;
  }
};

/**
 * This function will fetch HQV modal Data.
 * @returns {object} HQVmodal
 */
export const getHQVPageModel = async (path: string, locale: string, templateURL: string, sessionID: string) => {
  const getCMSTemplateReqBody = {
    requestType: ROUTING_CONFIG,
    seoUrl: path,
    localeKey: locale,
    experienceSegment: EXPERIENCE_SEGMENT,
    applicationName: APPLICATION_NAME,
    sessionToken: sessionID,
  };
  let pageModel = {};
  try {
    const response = await axios.post(`${templateURL}`, getCMSTemplateReqBody);
    if (response) {
      pageModel = response?.data?.data;
    } else {
      pageModel = {};
    }
  } catch (err) {
    // log.error(`HQV_MODEL_CALL : API call failed: ${err}`);
    //returing page model and logging error
    return pageModel;
  }
  return pageModel;
};

//converts ":items" format to "cqItems" format.
export function transformToCQ(propKey: string) {
  const tempKey = propKey.substring(1);

  return 'cq' + tempKey.substring(0, 1).toUpperCase() + tempKey.substring(1);
}

//To format mock model in local dev, in other envs this formatting is taken care by OOTB fetchModel utility
export const respGridUtil = (item: any) => {
  if (!item || !Object.keys(item).length) {
    return { cqPath: '' };
  }

  const keys = Object.getOwnPropertyNames(item);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const props: any = {};

  keys.forEach((key: string) => {
    const propKey = key.startsWith(':') ? transformToCQ(key) : key;
    props[propKey] = item[key] || '';
  });

  return props;
};
export { getLanguage, addSubDirectoryPrefix };

//This Function determines to disbale hyperlink and reviewcount
export const isReviewCountHidden = (currentLocale: string) => {
  const localWithReviewDisable = [LOCALE_ZH_CN];
  return localWithReviewDisable.includes(currentLocale);
};

export const getRateConversionFactor = (
  currentConverSionRateArr: {
    currency: string;
    currentConversionRate: number;
  }[],
  currency: string
) => {
  const currentConverSionRate = currentConverSionRateArr?.find(
    (key: { currency: string }) => key.currency === currency
  );
  return currentConverSionRate?.currentConversionRate ?? 1;
};

export const capitalize = (text: string) => {
  return `${text?.charAt(0)?.toUpperCase()}${text?.slice(1)?.toLowerCase()}`;
};

export async function updateSessionInSearchForm(
  sessionData: any,
  SESSION_APP_POST_CALL_URL: string,
  NEXT_PUBLIC_PREFIX: string,
  singleDateLimit: Date | string | Moment,
  groupDateLimit: Date | string | Moment,
  sessionID: string
) {
  // Define URLs and variables
  const postSessionUrl: any = SESSION_APP_POST_CALL_URL;
  const requestId = useClientEnvVarsStore.getState().envVarsObject?.['REQUEST_ID'];
  const removeBlock: any = [];
  try {
    const AriesUpdateSessionPayloadObject: any = {};
    if (sessionData?.cacheData?.data?.AriesCommon) {
      AriesUpdateSessionPayloadObject['AriesCommon.singleDateLimit'] = singleDateLimit;
      AriesUpdateSessionPayloadObject['AriesCommon.groupDateLimit'] = groupDateLimit;
    } else {
      AriesUpdateSessionPayloadObject['AriesCommon'] = {
        singleDateLimit: singleDateLimit,
        groupDateLimit: groupDateLimit,
      };
    }

    // Send a PATCH request to update the session
    await axios.patch(
      postSessionUrl,
      {
        createOrUpdate: AriesUpdateSessionPayloadObject,
        remove: removeBlock,
        sessionToken: sessionID,
      },
      {
        headers: {
          Cookie: `sessionID=${sessionID}`,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'x-request-id': requestId,
        },
      }
    );
  } catch (error) {
    // Handle and return any errors
    const loggerApiURL = getLoggerApiURL(NEXT_PUBLIC_PREFIX, true);
    axios.post(loggerApiURL, {
      message: `Error while making session call with sessionId ${sessionData?.sessionToken}: ${JSON.stringify(error)}`,
    });
  }
}

// function to get the logger api url
export const getLoggerApiURL = (NEXT_PUBLIC_PREFIX: string, isRemoteSpa = false) => {
  let loggerApiURL;
  if (isRemoteSpa) {
    loggerApiURL = '/api/shop-renderer/logger';
  } else {
    loggerApiURL = '/api/logger';
  }
  if (getDeployedEnvType() === 'higher') {
    return `${NEXT_PUBLIC_PREFIX}${loggerApiURL}`;
  } else {
    return loggerApiURL;
  }
};

//Function to return the translated values of specified currency
export const fetchCurrencyToLocale = (currentLocale: string, currencyLabel: string, currency?: string) => {
  switch (currentLocale) {
    case JP_LOCALE:
      return currency === 'JPY' ? currencyLabel : currency;
    case KR_LOCALE:
      return currency === 'KRW' ? currencyLabel : currency;
    default:
      return currency;
  }
};

//this function will convert all the Arabic number to english numbers
export const convertArabicToEnglishNumbers = (dateString: string): string => {
  // Arabic to English numeral mapping
  const arabicToEnglishMap: { [index: string]: string } = {
    '٠': '0',
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
  };

  // Replace Arabic numerals with English numerals
  return dateString.replace(/[٠-٩]/g, function (match) {
    return arabicToEnglishMap[match].toString();
  });
};

export const convertHindiToEnglishNumbers = (input: string): string => {
  // Hindi (Devanagari) to English numeral mapping
  const hindiToEnglishMap: { [key: string]: string } = {
    '०': '0',
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
  };

  // Replace Hindi numerals with English numerals
  return input.replace(/[०-९]/g, match => hindiToEnglishMap[match]);
};

//this function to return time in Arabic time of day format
export function getTimeInArabicTimeOfDayFormat(timeString: string): string {
  // Parse the time string with moment
  const time = moment(timeString, 'hh:mm A');

  if (!time.isValid()) {
    return timeString;
  }

  const hour = time.hour();

  const arabicSuffix =
    hour >= 6 && (hour <= 12 || (hour === 12 && time.minute() === 0))
      ? ARABIC_PERIODS.MORNING // Morning
      : hour > 12 && hour < 16
      ? ARABIC_PERIODS.NOON // Noon
      : hour >= 16 && hour < 18
      ? ARABIC_PERIODS.AFTERNOON // Afternoon
      : ARABIC_PERIODS.EVENING; // Evening

  // Format the time as hh:mm and append the Arabic suffix
  return convertArabicToEnglishNumbers(`${time.format('h:mm')} ${arabicSuffix}`);
}

//this finction will detect any currecny in a string and reorder the currecny symbol for RTL enabled site
export const reorderCurrencyForRTL = (inputString: string) => {
  // Regular expression to detect a currency and amount pattern
  const pattern = /\b(\d+\.\d{2})\s*([A-Z]{3})\b|\b([A-Z]{3})\s*(\d+\.\d{2})\b/g;

  // Function to handle the replacement
  function replaceMatch(
    match: string,
    amountBefore: string,
    currencyAfter: string,
    currencyBefore: string,
    amountAfter: string
  ) {
    if (amountBefore && currencyAfter) {
      // Match format: '70.00 USD'
      return `${currencyAfter} ${amountBefore}`;
    } else if (currencyBefore && amountAfter) {
      // Match format: 'USD 70.00'
      return `${currencyBefore} ${amountAfter}`;
    }
    return match;
  }

  // Replace all occurrences in the string
  return inputString.replace(pattern, replaceMatch);
};

//get the locale from document lang in client side
export const getLocaleFromDocument = () => {
  if (typeof document === 'undefined') return '';
  return document.documentElement?.lang;
};

//get the page dir property
export const getPageDirectionFromDocument = () => {
  if (typeof document === 'undefined') return '';
  return document.documentElement?.dir;
};

//this will check for any locale that requires number conversion to english
export const formatDateStringBasedOnLocale = (dateString: string) => {
  const locale = getLocaleFromDocument();

  if (locale === AR_LOCALE) {
    return convertArabicToEnglishNumbers(dateString);
  } else if (locale === HI_LOCALE) {
    return convertHindiToEnglishNumbers(dateString);
  } else {
    return dateString;
  }
};

const fetchSvg = async (url: string): Promise<string | null> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch SVG: ${response.statusText}`);
    }
    return await response.text();
  } catch (error) {
    return null;
  }
};

const updateSvgContent = (content: string) => {
  let svgElementString = null;
  if (content) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'image/svg+xml');
    const svgElement = doc.querySelector('svg'); //using query selector and not refs as this is svg string returned from AKAMAI and not the actual page document.
    const pathElement = svgElement?.querySelectorAll('path');
    pathElement &&
      pathElement.forEach(elm => {
        elm.setAttribute('fill', baseVariables.color['base20']);
      });
    if (svgElement !== null) {
      svgElementString = new XMLSerializer().serializeToString(svgElement);
    }
  }
  return svgElementString;
};
export const fetchSvgContent = async (brandId: string) => {
  const content: string = (await fetchSvg(
    `${process.env['NEXT_PUBLIC_ASSET_DOMAIN']}/mi-assets/mi-global/brand-logos/${brandId}.svg`
  )) as string;

  const updatedSvgContent = updateSvgContent(content);
  return updatedSvgContent as string;
};

export const toggleUnsuccessfulSellUrlParameter = (): void => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(window.location.search);
    if (params?.has(UNSUCCESSFULSELL)) {
      // toggle the value
      const currentParamValue = params?.get(UNSUCCESSFULSELL);
      const updatedParamsValue = currentParamValue === 'true' ? 'false' : 'true';
      params.set(UNSUCCESSFULSELL, updatedParamsValue);
      // update url search string
      url.search = params.toString();
      // replace current history with updated url
      window.history.replaceState({}, '', url);
    }
  }
};

/**
 * Conditionally toggles the 'unsuccessfulSell' URL parameter based on currency state.
 *
 * This function ensures the URL parameter 'unsuccessfulSell' is synchronized with the current currency:
 * - If the URL has 'unsuccessfulSell=true' but currency is NOT default → removes the parameter
 * - If the URL has 'unsuccessfulSell=false' (or missing) but currency IS default → adds the parameter
 *
 * This prevents the "unsuccessful journey" alert from showing inappropriately when users
 * change currency from default to non-default, and ensures it shows when they reset back to default.
 *
 * @param currCurrency - The current currency value to check against default currency
 */
export const conditionalToggleUnsuccessfulSellUrlParameter = (currCurrency: any): void => {
  const urlParams = new URLSearchParams(window.location.search);
  // Check if there's a mismatch between the URL parameter state and currency state
  // This condition evaluates to true when:
  // - URL has 'unsuccessfulSell=true' but currency is NOT default (should remove parameter)
  // - URL has 'unsuccessfulSell=false' or missing but currency IS default (should add parameter)
  if ((urlParams?.get(UNSUCCESSFULSELL) === 'true') !== (currCurrency === DEFAULT_CURRENCY)) {
    toggleUnsuccessfulSellUrlParameter();
  }
};

export const handlePropertyClicked = (recentlyViewed: any, setRecentlyViewed: any, id: string) => {
  const prevChecked = localStorage.getItem('recent')?.split(',');

  if (recentlyViewed && recentlyViewed.length > 0) {
    if (!recentlyViewed.includes(id)) {
      if (prevChecked && prevChecked.length > 0) {
        setRecentlyViewed([...prevChecked, ...recentlyViewed, id]);
      } else {
        setRecentlyViewed([...recentlyViewed, id]);
      }
    }
  } else {
    if (prevChecked && prevChecked.length > 0) {
      setRecentlyViewed([...prevChecked, id]);
    } else {
      setRecentlyViewed([id]);
    }
  }
};

/**
 * Safely construct an absolute/relative URL for redirects.
 * Accepts relative paths and absolute URLs
 */
export const sanitizeRedirectUrl = (inputUrl: string | null | undefined): string | null => {
  if (!inputUrl || typeof window === 'undefined') return null;
  try {
    // decode and build
    const decoded = decodeURIComponent(inputUrl);
    const url = new URL(decoded);
    return url.href;
  } catch {
    return null;
  }
};

export async function updateSessionForSpecialRates(
  sessionData: any,
  SESSION_GET_CALL_URL_CLIENT: string,
  NEXT_PUBLIC_PREFIX: string
) {
  const requestId = useClientEnvVarsStore.getState().envVarsObject['REQUEST_ID'];
  const removeBlock: any = [];
  const sessionObj = sessionData.data ? sessionData : sessionData.cacheData;
  const sessionToken = sessionObj?.data?.sessionToken || sessionObj?.key || getSessionIDFromCookie() || '';
  try {
    const AriesUpdateSessionPayloadObject: any = {};
    if (sessionObj?.data?.AriesSearch) {
      AriesUpdateSessionPayloadObject['AriesSearch.searchCriteria.availabilityRequestVO.clusterCode'] = 'none';
      AriesUpdateSessionPayloadObject['AriesSearch.searchCriteria.availabilityRequestVO.corporateCode'] = '';

      // Send a POST request to update the session
      await axios.patch(
        SESSION_GET_CALL_URL_CLIENT,
        {
          createOrUpdate: AriesUpdateSessionPayloadObject,
          remove: removeBlock,
          sessionToken,
        },
        {
          headers: {
            Cookie: `sessionID=${sessionToken}`,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'x-request-id': requestId,
          },
        }
      );
    } else {
      return;
    }
  } catch (error) {
    // Handle and return any errors
    const loggerApiURL = getLoggerApiURL(NEXT_PUBLIC_PREFIX, true);
    axios.post(loggerApiURL, {
      message: `Error while making session call with sessionId ${sessionData?.sessionToken}: ${JSON.stringify(error)}`,
    });
  }
}

/**
 * Gets sessionID value from browser cookie.
 * Returns undefined when not in browser (e.g. SSR).
 */
export function getSessionIDFromCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  return document?.cookie?.split('sessionID=')[1]?.split(';')[0];
}




